// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@-webkit-keyframes scroll-marquee{0%{transform:translateX(0)}to{transform:translateX(calc(-100% - 12px))}}@keyframes scroll-marquee{0%{transform:translateX(0)}to{transform:translateX(calc(-100% - 12px))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
